<div style="float: right; padding-right: 30px;">
	<button [disabled]="modalShowing" (click)="modalShowing = true; showNetworkSyncModal();" *ngIf="serviceId > 0 && showNetworkSync" class="btn btn-info">{{serviceName}} Global Sync</button>
</div>